import {
  ArrowLeftCircle,
  Camera,
  CreditCard,
  Dialpad,
  Female,
  Gift,
  Mail,
  Male,
  SmartphoneDevice,
} from "iconoir-react";
import { inject, observer } from "mobx-react";
import { Upload } from "antd";

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { EmptyText } from "../components/common/CellText";
import EditIcon from "../components/image/EditIcon";
import { getNameInCapitalize } from "../utils/common";
import Avatar from "@mui/material/Avatar";
import { Button, Menu, MenuItem, useTheme } from "@mui/material";
import { useKeycloak } from "@react-keycloak/web";
import { useSSO } from "../config";
import MuiAlert from "@mui/material/Alert";
import moment from "moment";
import { DATE_FORMAT_DEFAULT } from "../utils/constants";
import Message from "../components/common/Message";
import MainLayout from "../layouts/MainLayout";
import { BiCog } from "react-icons/bi";
React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const nullText = <EmptyText>Chưa cập nhật</EmptyText>;
const ProfilePage = ({
  userStore,
  authenticationStore,
  accountStore,
  aclStore,
  notificationStore,
}) => {
  const { aclAclGroupName } = aclStore;
  const navigate = useNavigate();
  const { currentUser, currentUserAvatar } = authenticationStore;
  const [openMessage, setOpenMessage] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const disabledKeyCloak = {
    keycloak: null,
  };
  const theme = useTheme();
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { keycloak } = useSSO ? useKeycloak() : disabledKeyCloak;
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleUpdate = () => {
    setAnchorEl(null);
    navigate("/update-profile");
  };
  const handleLogout = () => {
    setAnchorEl(null);
    accountStore.clearStore();
    // companyStore.clearStore()
    userStore.clearStore();
    notificationStore.clearStore();
    authenticationStore.userLogout();
    if (keycloak) {
      keycloak.logout();
    }

    if (!useSSO) {
      navigate.replace("/");
    }

    // messaging
    //     ?.deleteToken()
    //     .then((res) => console.log(res))
    //     .catch((err) => console.log(err));
  };
  const handleUploadAvatar = async (file, fileList) => {
    if (file.size / 1000 / 1024 > 3) {
      setOpenMessage(true);
    } else {
      const formData = new FormData();
      formData.append("file", fileList[0]);
      try {
        await authenticationStore.updateCurrentUserAvatar(formData);
        await authenticationStore.getCurrentUserAvatar();
      } catch (err) {
        console.log(err);
      } finally {
      }
    }
    return false;
  };
  return (
    <>
      <div
        className="flex justify-between items-center py-[20px] pl-[60px] pr-[20px]"
        style={{
          background: theme.background.header,
          color: theme.color.text1,
        }}
      >
        <div
          style={{
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            width: "90%",
            marginRight: "10px",
          }}
          className="font-bold text-[28px] leading-[29px]"
        >
          Trang cá nhân
        </div>

        <div className="absolute ml-1 right-0">
          <Button
            id="basic-button"
            aria-controls={open ? "basic-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <BiCog style={{ color: theme.color.text1 }} fontSize={25} />
          </Button>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              "aria-labelledby": "basic-button",
            }}
          >
            <MenuItem
              sx={{
                color: "#0073C7 !important",
                borderBottom: "1px solid rgba(0,0,0,0.05)",
              }}
              onClick={handleUpdate}
            >
              Cập nhật thông tin
            </MenuItem>
            <MenuItem
              onClick={handleClose}
              sx={{
                borderBottom: "1px solid rgba(0,0,0,0.05)",
              }}
            >
              Đổi mật khẩu
            </MenuItem>
            <MenuItem
              sx={{
                color: "red",
                borderBottom: "1px solid rgba(0,0,0,0.05)",
              }}
              onClick={handleLogout}
            >
              Đăng xuất
            </MenuItem>
          </Menu>
        </div>
      </div>
      <MainLayout>
        <div className="px-5 pb-[96px] ">
          <section className="relative overflow-hidden  mt-[18px]  bg-[#0073C7] text-white rounded-[9px] px-[18px] py-[28px] flex justify-between items-center">
            <div className="flex items-center justify-between gap-x-6">
              <div className="w-[110px] h-[110px] ">
                <div className="absolute z-10 w-[110px] h-[110px] rounded-full border-[2px] border-white bg-white">
                  <Avatar
                    alt=""
                    src={
                      currentUserAvatar &&
                      URL.createObjectURL(currentUserAvatar)
                    }
                    sx={{ width: "100%", height: "100%" }}
                  />
                  <Upload beforeUpload={handleUploadAvatar}>
                    <div
                      htmlFor="upload-image"
                      className="absolute flex items-center justify-center p-1 bg-white rounded-full bottom-2 right-2 "
                    >
                      <Camera
                        className="text-lightText"
                        width={10}
                        height={10}
                      />
                    </div>
                  </Upload>
                </div>
              </div>
              <div>
                <div className="leading-[21px] mb-2 text-xl font-bold ">
                  {getNameInCapitalize(currentUser?.name_lowercase) || nullText}
                </div>
                <div className="leading-[8px] font-semibold bg-white text-primaryText text-[8px] inline-block px-[6px] py-1 rounded-sm">
                  {currentUser?.position?.name || nullText}
                </div>
                <div className="flex items-center mt-2 leading-[10px]">
                  <span className="px-1">•</span>{" "}
                  <span className="font-semibold text-[10px]  ">
                    Tài khoản: {currentUser?.username || nullText}
                  </span>
                </div>
                <div className="flex items-center mt-2 leading-[10px]">
                  <span className="px-1">•</span>{" "}
                  <span className="font-semibold text-[10px]  ">
                    {aclAclGroupName}
                  </span>
                </div>
              </div>
            </div>
          </section>
          <div>
            <div className="text-lightText font-semibold text-sm leading-[15px] mt-6">
              Email
            </div>
            <div className="flex items-center py-[14px] px-5 bg-[#F8F8F8] rounded-lg mt-2">
              <Mail
                className="mr-5"
                style={{ minHeight: 14, minWidth: 20 }}
                color="#23374D"
              />
              <span
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  width: "100%",
                }}
                className="text-[#23374D] font-medium text-base leading-[17px]"
              >
                {currentUser?.email || nullText}
              </span>
            </div>
            <div className="text-lightText font-semibold text-sm leading-[15px] mt-6">
              Mã nhân viên
            </div>
            <div className="flex items-center py-[14px] px-5 bg-[#F8F8F8] rounded-lg mt-2">
              <CreditCard
                className="mr-5"
                style={{ minHeight: 14, minWidth: 20 }}
                color="#23374D"
              />
              <span
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  width: "100%",
                }}
                className="text-[#23374D] font-medium text-base leading-[17px]"
              >
                {currentUser?.ma_nv || nullText}
              </span>
            </div>
            <div className="text-lightText font-semibold text-sm leading-[15px] mt-5">
              Số máy nội bộ
            </div>
            <div className="flex items-center py-[14px] px-5 bg-[#F8F8F8] rounded-lg mt-2">
              <Dialpad
                className="mr-5"
                style={{ minHeight: 14, minWidth: 20 }}
                color="#23374D"
              />
              <span
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  width: "100%",
                }}
                className="text-[#23374D] font-medium text-base leading-[17px]"
              >
                {currentUser?.home_phone || nullText}
              </span>
            </div>
            <div className="text-lightText font-semibold text-sm leading-[15px] mt-5">
              Di động
            </div>
            <div className="flex items-center py-[14px] px-5 bg-[#F8F8F8] rounded-lg mt-2">
              <SmartphoneDevice
                className="mr-5"
                style={{ minHeight: 14, minWidth: 20 }}
                color="#23374D"
              />
              <span
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  width: "100%",
                }}
                className="text-[#23374D] font-medium text-base leading-[17px]"
              >
                {currentUser?.phone || nullText}
              </span>
            </div>
            <div className="text-lightText font-semibold text-sm leading-[15px] mt-5">
              Giới tính
            </div>
            <div className="flex items-center py-[14px] px-5 bg-[#F8F8F8] rounded-lg mt-2">
              {currentUser?.gender === 0 ? (
                <Female
                  className="mr-5"
                  style={{ minHeight: 14, minWidth: 20 }}
                  color="#23374D"
                />
              ) : (
                <Male
                  className="mr-5"
                  style={{ minHeight: 14, minWidth: 20 }}
                  color="#23374D"
                />
              )}
              <span
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  width: "100%",
                }}
                className="text-[#23374D] font-medium text-base leading-[17px]"
              >
                {(currentUser?.gender === 0 ? "Nữ" : "Nam") || nullText}
              </span>
            </div>
            <div className="text-lightText font-semibold text-sm leading-[15px] mt-5">
              Ngày sinh
            </div>
            <div className="flex items-center py-[14px] px-5 bg-[#F8F8F8] rounded-lg mt-2">
              <Gift
                className="mr-5"
                style={{ minHeight: 14, minWidth: 20 }}
                color="#23374D"
              />
              <span
                style={{
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  width: "100%",
                }}
                className="text-[#23374D] font-medium text-base leading-[17px]"
              >
                {currentUser?.birthDate
                  ? moment(currentUser?.birthDate).format(DATE_FORMAT_DEFAULT)
                  : nullText}
              </span>
            </div>
          </div>
          <Message
            message='Vui lòng chọn file {"<"} 3MB'
            openMessage={openMessage}
            severity="warning"
            closeMessage={() => {
              setOpenMessage(false);
            }}
          />
        </div>
      </MainLayout>
    </>
  );
};

export default inject(
  "userStore",
  "authenticationStore",
  "aclStore",
  "accountStore",
  "notificationStore"
)(observer(ProfilePage));
